// Generated by ts-to-zod
import { z } from 'zod';

export const genericEngineGetQuerySchema = z
  .object({
    fields: z.array(
      z.union([
        z.literal('id'),
        z.literal('name'),
        z.literal('url'),
        z.literal('schema'),
        z.literal('description'),
      ])
    ),
  })
  .partial();
